
      <div class="ui-g-12 sf-field-container">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [attr.for]="id" [ngClass]="{'required': -1!==(formProperty.parent.schema.required||[]).indexOf(formProperty.path.split('/').slice(-1)[0])}">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-8">
          <p-calendar
            #calendar
            [dateFormat]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
            [locale]="srvCalendarTranslate.pcalendarTranslate"
            showIcon="true"
            yearRange="1900:2099"
            [placeholder]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
            inputName="schema.description"
            [(ngModel)]="dateValue"
            [defaultDate]="dateValue"
            (onSelect)="update(calendar)"
            [readonlyInput]="true"
            [monthNavigator]="true"
            [yearNavigator]="true"
            [disabled]="schema.readOnly||false"
          ></p-calendar>
        </div>
      </div>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/calendar.widget.ts.CalendarWidget.html